import { AccountStatusAccepted, AccountStatusArchived, AccountStatusDeclined, AccountStatusPending } from '@app/components/various/Icons';
import { AccountRequestStatus } from '@app/constants/requests';
import { isDefined } from '@app/utils/is';

interface Props {
  type: AccountRequestStatus | null;
  className?: string;
}

const ICON_MAP: Record<AccountRequestStatus, (props: React.SVGProps<SVGSVGElement>) => JSX.Element> = {
  [AccountRequestStatus.Accepted]: AccountStatusAccepted,
  [AccountRequestStatus.Archived]: AccountStatusArchived,
  [AccountRequestStatus.Declined]: AccountStatusDeclined,
  [AccountRequestStatus.Pending]: AccountStatusPending,
};

export const RequestStatus = ({ type, className = 'size-2.5' }: Props) => {
  if (!isDefined(type)) {
    return null;
  }

  const Icon = ICON_MAP[type];

  return <Icon className={className} />;
};
